import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router";

const navLinks = [
  { label: "Home", to: "/", icon: "" },
  { label: "Our Dogs", to: "/dogs", icon: "" },
  { label: "Puppies", to: "/puppies", icon: "" },
  { label: "Contacts", to: "/contacts", icon: "" },
];

const NavBar = () => {
  return (
    <Box
      component="nav"
      sx={{
        backgroundColor: "#4a3728",
        borderTop: "2px solid #d4b483",
        borderBottom: "2px solid #d4b483",
        position: "sticky",
        top: 0,
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {navLinks.map((link) => (
          <Button
            key={link.label}
            component={Link}
            to={link.to}
            sx={{
              color: "#f5e6c8",
              px: { xs: 1.5, md: 3 },
              py: 1.5,
              fontSize: { xs: "0.75rem", md: "0.85rem" },
              fontWeight: 500,
              letterSpacing: 1,
              textTransform: "uppercase",
              borderRadius: 0,
              position: "relative",
              "&:hover": {
                backgroundColor: "rgba(212,180,131,0.15)",
                color: "#d4b483",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%) scaleX(0)",
                width: "60%",
                height: 2,
                backgroundColor: "#d4b483",
                transition: "transform 0.3s",
              },
              "&:hover::after": {
                transform: "translateX(-50%) scaleX(1)",
              },
            }}
          >
            {link.icon && (
              <Typography component="span" sx={{ mr: 0.5, fontSize: "1rem" }}>
                {link.icon}
              </Typography>
            )}
            {link.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default NavBar;
